import { DbRef } from "./firebase";
export var OfficeLogoSize;
(function (OfficeLogoSize) {
    OfficeLogoSize["SMALL"] = "small";
    OfficeLogoSize["MEDIUM"] = "medium";
    OfficeLogoSize["LARGE"] = "large";
})(OfficeLogoSize || (OfficeLogoSize = {}));
export var OfficeStatus;
(function (OfficeStatus) {
    OfficeStatus["REQUIRE_INTERVIEW"] = "requireInterview";
    OfficeStatus["INTERVIEW_SCHEDULED"] = "interviewScheduled";
    OfficeStatus["APPROVED"] = "approved";
    OfficeStatus["DECLINED"] = "declined";
})(OfficeStatus || (OfficeStatus = {}));
export var OfficeType;
(function (OfficeType) {
    OfficeType["LAB"] = "lab";
    OfficeType["PHYSICIAN"] = "physician";
    OfficeType["STAFFING"] = "staffing";
    /** @deprecated */
    /** Prescribing office */
    OfficeType["STANDARD"] = "standard";
    /** @deprecated */
    /** Office associated with a lab */
    OfficeType["VENDOR"] = "vendor";
})(OfficeType || (OfficeType = {}));
export const OfficeRelationshipKeys = {
    assistants: { ref: DbRef.USERS },
    partners: { ref: DbRef.OFFICES },
    patients: { ref: DbRef.USERS },
    prescribers: { ref: DbRef.USERS },
    sharedPlaceAccounts: { ref: DbRef.USERS },
};
export var OfficeInvitationStatus;
(function (OfficeInvitationStatus) {
    OfficeInvitationStatus["ACCEPTED"] = "accepted";
    OfficeInvitationStatus["PENDING"] = "pending";
})(OfficeInvitationStatus || (OfficeInvitationStatus = {}));
export var GenericOfficeIDs;
(function (GenericOfficeIDs) {
    GenericOfficeIDs["PATIENT_INITIATED"] = "--genericPatientInitiatedOffice";
})(GenericOfficeIDs || (GenericOfficeIDs = {}));
export var BillingOption;
(function (BillingOption) {
    BillingOption["CHARGE_PATIENT"] = "chargePatient";
    BillingOption["CHARGE_OFFICE"] = "chargeOffice";
})(BillingOption || (BillingOption = {}));
//# sourceMappingURL=office.js.map